import { useQuery } from '@tanstack/react-query';
import { useRef } from 'react';
import { GET_ALL_PERIODS_AS_ADMIN_PERIODS } from '../../../../constants/queryKeys';
import { PeriodConfigOverview } from './PeriodConfigOverview';
import { ApiCalls } from '../../../../api/api';
import { Period } from '../../../../api/generated/data-contracts';

export const PeriodConfig = () => {
    const defaultData = useRef([] as Period[]).current;

    const { data: allPeriods = defaultData, isLoading } = useQuery({
        queryKey: [GET_ALL_PERIODS_AS_ADMIN_PERIODS],
        queryFn: () => ApiCalls.getAllPeriodsAsAdminPeriods({}).then(res => res.data),
        placeholderData: defaultData,
        suspense: true,
    });

    return <PeriodConfigOverview allPeriods={allPeriods} isLoading={isLoading} />;
};
